/**
 * Browser enrollment record (plan §A4) — see trackingCore.ts for the rules.
 * initEnrollment() runs once in main.tsx after attribution + variant capture.
 */
import { ENROLLMENT_KEY, ensureEnrollment, readEnrollment, restoreIfMissing, type EnrollmentRecord, type KVStorage } from './trackingCore'
import { getAttribution } from './attribution'
import { getVariant } from './variant'

let cached: EnrollmentRecord | null = null

function storage(): KVStorage | null {
  try {
    return typeof localStorage !== 'undefined' ? localStorage : null
  } catch {
    return null
  }
}

function newId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID()
  return `enr-${Date.now()}-${Math.random().toString(36).slice(2)}`
}

export function initEnrollment(): EnrollmentRecord {
  cached = ensureEnrollment(storage(), {
    nowMs: Date.now(),
    utmCampaign: getAttribution()?.utm_campaign,
    variant: getVariant(),
    newId,
  })
  return cached
}

/**
 * This page's enrollment (held in memory). Runs on every funnel event, so if
 * iOS dropped storage mid-page the record is written back before a reload
 * can mint a second one.
 */
export function getEnrollment(): EnrollmentRecord {
  if (!cached) cached = readEnrollment(storage()) || initEnrollment()
  restoreIfMissing(storage(), ENROLLMENT_KEY, JSON.stringify(cached))
  return cached
}
